import React from "react";

const strokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

function Glyph({ name }) {
  switch (name) {
    case "language":
      return (
        <>
          <circle cx="12" cy="12" r="9" />
          <path d="M3.5 9h17M3.5 15h17M12 3c2.2 2.4 3.3 5.4 3.3 9S14.2 18.6 12 21M12 3C9.8 5.4 8.7 8.4 8.7 12s1.1 6.6 3.3 9" />
        </>
      );
    case "arrow-up-right":
      return <path d="M7 17 17 7M8 7h9v9" />;
    case "arrow-right":
      return <path d="M5 12h14M14 7l5 5-5 5" />;
    case "arrow-left":
      return <path d="m10 7-5 5 5 5M5 12h14" />;
    case "check":
      return <path d="m5 12 4 4L19 6" />;
    case "sparkles":
      return (
        <>
          <path d="M12 3c.7 4 2 5.3 6 6-4 .7-5.3 2-6 6-.7-4-2-5.3-6-6 4-.7 5.3-2 6-6Z" />
          <path d="M18.5 15.5c.3 1.8.9 2.4 2.5 2.7-1.6.3-2.2.9-2.5 2.8-.3-1.9-.9-2.5-2.5-2.8 1.6-.3 2.2-.9 2.5-2.7Z" />
        </>
      );
    case "search":
      return (
        <>
          <circle cx="11" cy="11" r="6.5" />
          <path d="m16 16 4 4" />
        </>
      );
    case "box":
      return (
        <>
          <path d="m4 8 8-4 8 4-8 4-8-4Z" />
          <path d="m4 8 8 4 8-4v8l-8 4-8-4V8ZM12 12v8" />
        </>
      );
    case "layers":
      return (
        <>
          <path d="m12 3 9 5-9 5-9-5 9-5Z" />
          <path d="m3 12 9 5 9-5M3 16l9 5 9-5" />
        </>
      );
    case "desktop":
      return (
        <>
          <rect x="3" y="4" width="18" height="13" rx="2" />
          <path d="M8 21h8M12 17v4" />
        </>
      );
    case "tablet":
      return (
        <>
          <rect x="5" y="2.5" width="14" height="19" rx="2.5" />
          <path d="M11 18.5h2" />
        </>
      );
    case "mobile":
      return (
        <>
          <rect x="7" y="2.5" width="10" height="19" rx="2.5" />
          <path d="M11 18.5h2" />
        </>
      );
    case "close":
      return <path d="m6 6 12 12M18 6 6 18" />;
    case "edit":
      return (
        <>
          <path d="M13.5 6.5 17.5 10.5M5 19l3.2-.7L19 7.5a2.8 2.8 0 0 0-4-4L4.2 14.3 4 20l5.7-.2" />
        </>
      );
    case "palette":
      return (
        <>
          <path d="M12 3a9 9 0 1 0 0 18h1.2a2 2 0 0 0 1.3-3.5 2 2 0 0 1 1.3-3.5H18a3 3 0 0 0 3-3c0-4.4-4-8-9-8Z" />
          <circle cx="7.5" cy="10" r=".7" fill="currentColor" stroke="none" />
          <circle cx="10" cy="6.8" r=".7" fill="currentColor" stroke="none" />
          <circle cx="14" cy="6.8" r=".7" fill="currentColor" stroke="none" />
        </>
      );
    case "pages":
      return (
        <>
          <rect x="6" y="4" width="13" height="16" rx="2" />
          <path d="M6 8H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10M10 9h5M10 13h5" />
        </>
      );
    case "download":
      return (
        <>
          <path d="M12 3v12M7 10l5 5 5-5M4 20h16" />
        </>
      );
    case "shield":
      return (
        <path d="M12 3 5 6v5c0 4.7 2.8 8.3 7 10 4.2-1.7 7-5.3 7-10V6l-7-3Zm-3 9 2 2 4-4" />
      );
    case "plus":
      return <path d="M12 5v14M5 12h14" />;
    case "mail":
      return (
        <>
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <path d="m4 7 8 6 8-6" />
        </>
      );
    case "eye":
      return (
        <>
          <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
          <circle cx="12" cy="12" r="2.6" />
        </>
      );
    case "eye-off":
      return (
        <>
          <path d="M3 3l18 18M10.6 6.2A10.7 10.7 0 0 1 12 6c6 0 9.5 6 9.5 6a16 16 0 0 1-2.7 3.3M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6c1 0 1.9-.2 2.8-.5M9.9 9.9a3 3 0 0 0 4.2 4.2" />
        </>
      );
    default:
      return <circle cx="12" cy="12" r="8" />;
  }
}

function GoogleGlyph() {
  return (
    <g fill="none" strokeWidth="2.7" strokeLinecap="round">
      <path
        stroke="#4285F4"
        d="M20.3 12.2c0-.7-.1-1.3-.2-1.9H12v3.4h4.7a4 4 0 0 1-1.8 2.7"
      />
      <path stroke="#34A853" d="M14.9 16.4a5.4 5.4 0 0 1-8-2.8" />
      <path stroke="#FBBC05" d="M6.9 13.6A5.3 5.3 0 0 1 6.9 10" />
      <path stroke="#EA4335" d="M6.9 10a5.4 5.4 0 0 1 8.1-2.8" />
    </g>
  );
}

export default function Icon({ name, size = 16 }) {
  return (
    <span className={`icon icon-${name}`} aria-hidden="true">
      <svg
        viewBox="0 0 24 24"
        width={size}
        height={size}
        focusable="false"
        {...(name === "google" ? {} : strokeProps)}
      >
        {name === "google" ? <GoogleGlyph /> : <Glyph name={name} />}
      </svg>
    </span>
  );
}
